import axios from 'axios'
import { BASE_URL } from './Constants';

const CancelToken = axios.CancelToken;
export const cancelTokenSource = CancelToken.source();

export const api = axios.create({
    baseURL: BASE_URL,
})